import VConsole from 'vconsole';
import { setLocalStorage } from './index';

//vant 桌面端适配
import '@vant/touch-emulator';
// TODO: 进一步拆分
// VConsole 拆出且支持环境变量配置是否启用
setIosInputFocus();
setFontSize();
prohibitAndroidAdjustmentSize();
setVConsole();
// 解决ios下输入框点击不唤起软键盘的bug
function setIosInputFocus(): void {
  document.body.addEventListener('click', (e) => {
    const dom = e.target as HTMLElement;
    const { tagName } = dom;
    if (tagName === 'INPUT' || tagName === 'TEXTAREA' || dom.getAttribute('contenteditable') === 'true') {
      dom.focus();
    }
  });
}

// 设置字体
function setFontSize(): void {
  const setRem = () => {
    let deviceWidth = document.documentElement.clientWidth;
    // 获取相对UI稿，屏幕的缩放比例
    if (deviceWidth > 1024) {
      deviceWidth = 1024;
    }
    const scale = deviceWidth / 750;
    window.scale = scale;
    // 动态设置html的font-size
    document.querySelector('html')!.style.fontSize = 100 * scale + 'px';
  };

  setRem();

  // 窗口改变重新设置
  window.onresize = function () {
    setRem();
  };
}

function setVConsole(): void {
  // 判断url是否添加了fe-debug查询参数
  const isFeDebug =
    location.search.includes('debug') || location.search.includes('_fe_debug') || sessionStorage.getItem('_fe_debug');

  // 如果添加了,写入控制vConsole显示的标志位
  // 如果当前会话开启了vConsole,则本次会话一直显示vConsole
  if (isFeDebug && !sessionStorage.getItem('keepVConsoleShow')) {
    sessionStorage.setItem('keepVConsoleShow', 'true');
  }

  // vConsole组件会读取vConsole_switch_y的值,设置vConsole浮标距离页面底部的高度
  setLocalStorage('vConsole_switch_y', 300);
  // 设置 vConsole 在dev模式下默认显示。其它环境在 url 上加参数_fe_debug后显示
  if (
    import.meta.env.MODE === 'dev' ||
    import.meta.env.MODE === 'development' ||
    sessionStorage.getItem('keepVConsoleShow')
  ) {
    new VConsole({});
    const timer: any = setInterval(() => {
      let consoleDom: HTMLElement | null = document.querySelector('#__vconsole');
      if (consoleDom) {
        consoleDom && (consoleDom.style.display = 'block');
        consoleDom = null;
        clearInterval(timer);
      }
    }, 1000);
  }
}

function prohibitAndroidAdjustmentSize() {
  if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handleFontSize);
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    });
  }
}
